// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1d0DB","messages":"Chat_messages__1Ypzc","dateDivider":"Chat_dateDivider__3XS92"};